import { useEffect, useState } from 'react';
import { siteName } from '@/mocks/manga';

const navLinks = [
  { key: 'hero', label: '首页' },
  { key: 'categories', label: '分类导航' },
  { key: 'hot', label: '热门推荐' },
  { key: 'featured', label: '编辑精选' },
  { key: 'faq', label: '常见问题' },
  { key: 'about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTo = (key: string) => {
    setOpen(false);
    const el = document.getElementById(key);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 shadow-sm backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <button
          type="button"
          onClick={() => goTo('hero')}
          className="flex cursor-pointer items-center gap-2"
          aria-label="返回首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-sparkling-2-fill text-xl" />
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-900">
            {siteName}
          </span>
        </button>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <li key={l.key}>
              <button
                type="button"
                onClick={() => goTo(l.key)}
                className="cursor-pointer rounded-full px-4 py-2 text-sm text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <button
            type="button"
            onClick={() => goTo('hot')}
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始阅读
          </button>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-800 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 py-4 backdrop-blur-md md:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <li key={l.key}>
                <button
                  type="button"
                  onClick={() => goTo(l.key)}
                  className="w-full cursor-pointer rounded-md px-4 py-3 text-left text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <button
                type="button"
                onClick={() => goTo('hot')}
                className="mt-2 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-center text-sm font-medium text-background-50"
              >
                开始阅读
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}